import { render } from "./target_history_form.vue?vue&type=template&id=230b96b8&scoped=true"
import script from "./target_history_form.vue?vue&type=script&lang=js"
export * from "./target_history_form.vue?vue&type=script&lang=js"

import "./target_history_form.vue?vue&type=style&index=0&id=230b96b8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-230b96b8"]])

export default __exports__